<!-- CONTAINER -->
<div class="container content-area relative">

    <!-- PAGE-HEADER -->
    <div class="page-header">
        <h4 class="page-title">Guidance </h4>
        <ol class="breadcrumb">
            <li class="breadcrumb-item"><a [routerLink]="['/admin/dashboard']">Home</a></li>
            <li class="breadcrumb-item"><a [routerLink]="['/admin/order/guidance']">Guidance</a></li>
            <li class="breadcrumb-item active" aria-current="page">Details</li>
        </ol>
    </div>
    <!-- PAGE-HEADER END -->

    <!-- ROW-1 OPEN -->
    <div class="row" id="user-profile">
        <div class="col-lg-8 col-md-4">
            <div class="card">
                <div class="border-top">
                    <div class="wideget-user-tab">
                        <div class="tab-menu-heading">
                            <div class="tabs-menu1">
                                <div class="card-body">
                                    <div class="border-0">
                                        <div class="tab-content">
                                            <div class="tab-pane active show" id="tab-51">
                                                <div id="profile-log-switch">
                                                    <div class="media-heading d-flex justify-content-between">
                                                        <h4>
                                                            Guidance Details
                                                            <span *ngIf="data.is_first_order"
                                                                class="rounded-1 p-1 text-bg-success">FIRST ORDER</span>

                                                        </h4>

                                                    </div>

                                                    <hr class="m-0" />

                                                    <div class="table-responsive">
                                                        <table class="table row table-borderless">
                                                            <tbody class="col-lg-12 col-xl-12 p-0">

                                                                <tr>
                                                                    <td><strong>Guidance Category :</strong> {{
                                                                        data.guidanceCategoryName }}</td>
                                                                </tr>
                                                                <tr>
                                                                    <td><strong>Card Name :</strong> {{
                                                                        data.guidanceCardName }}</td>
                                                                </tr>
                                                                <tr>
                                                                    <td>
                                                                        <strong>Guidance Brief :</strong>

                                                                        <div [innerHTML]="data.guidanceBrief">
                                                                        </div>

                                                                    </td>
                                                                </tr>
                                                                <tr>
                                                                    <td>
                                                                        <strong>Guidance Detail :</strong>

                                                                        <div [innerHTML]="data.guidanceDetail"> </div>
                                                                    </td>
                                                                </tr>
                                                            </tbody>

                                                            <tbody class="col-lg-6 col-xl-6 p-0">

                                                                <tr>
                                                                    <td><strong>Order On :</strong> {{ data.created_at |
                                                                        date: 'medium' }}</td>
                                                                </tr>
                                                                <tr>
                                                                    <td>
                                                                        <strong>Status :</strong>
                                                                        <span
                                                                            class="rounded-1 p-1 text-bg-info">{{data.order_current_status}}</span>


                                                                    </td>
                                                                </tr>
                                                                <tr *ngIf="data.is_astro_answer">
                                                                    <td><strong>First Answer On :</strong> {{
                                                                        data.first_answer_time | date: 'medium' }}</td>
                                                                </tr>
                                                            </tbody>

                                                            <tbody class="col-lg-6 col-xl-6 p-0">
                                                                <tr>
                                                                    <td>
                                                                        <strong>Paid Amount :</strong>
                                                                        {{ data.orderserviceId?.customerCurrencySymbol
                                                                        }}{{ data?.orderserviceId?.customer_amount }}
                                                                        ({{ data.orderserviceId?.customerCurrencyCode
                                                                        }})
                                                                    </td>
                                                                </tr>

                                                                <tr>
                                                                    <td><strong>Company Share :</strong> {{
                                                                        data.company_amount | currency:
                                                                        'INR':'symbol-narrow' }}</td>
                                                                </tr>
                                                                <tr *ngIf="data.is_astro_answer">
                                                                    <td><strong>Last Answer On :</strong> {{
                                                                        data.last_answer_time | date: 'medium' }}</td>
                                                                </tr>
                                                            </tbody>



                                                            <tbody class="col-lg-12 col-xl-12 p-0"
                                                                *ngIf="data?.is_order_reviewed">
                                                                <tr>
                                                                    <td><strong>Customer Review:</strong> "{{
                                                                        data.customer_review }}"</td>
                                                                </tr>
                                                                <tr>
                                                                    <td><strong>Rating:</strong> {{
                                                                        data.customer_review_stars }} / 5</td>
                                                                </tr>
                                                                <tr>
                                                                    <td><strong>Reviewed On:</strong> {{
                                                                        data.review_given_date | date: 'medium' }}</td>
                                                                </tr>
                                                            </tbody>
                                                            <tbody class="col-lg-12 col-xl-12 p-0"
                                                                *ngIf="data?.is_feedback_given">
                                                                <tr>
                                                                    <td><strong>Customer Feedback:</strong> "{{
                                                                        data.feedback_value }}"</td>
                                                                </tr>

                                                                <tr>
                                                                    <td><strong>Reviewed On:</strong> {{
                                                                        data.feedback_date | date: 'medium' }}</td>
                                                                </tr>
                                                            </tbody>


                                                        </table>
                                                    </div>
                                                </div>

                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>


            <!-- astrologer feedback history -->
        </div>
        <!-- COL-END -->
        <div class="col-lg-4 col-md-4">


            <div class="card productdesc">
                <div class="card-body">
                    <div class="panel panel-primary">
                        <div class="tab-menu-heading">
                            <div class="tabs-menu"
                                [routerLink]="['/admin/customers/viewCustomer/', data.customerId?._id, 'detail']">
                                <!-- Tabs -->
                                <ul class="nav panel-tabs">
                                    <li class="custom-tab">
                                        <a href="javascript:void(0)" class="active" data-toggle="tab">Customer
                                            Details</a>
                                    </li>
                                </ul>
                            </div>
                        </div>
                        <div class="panel-body tabs-menu-body">
                            <div class="tab-content">
                                <div class="tab-pane active" id="tab1">
                                    <ul class="list-unstyled mb-0">
                                        <li class="row">
                                            <div class="col-sm-3 text-muted">Customer ID</div>
                                            <div class="col-sm-9">
                                                <a
                                                    [routerLink]="['/admin/customers/viewCustomer/', data.customerId?._id, 'detail']">#{{
                                                    data.customerId?.customerAutoId }}</a>
                                            </div>
                                        </li>
                                        <li class="row">
                                            <div class="col-sm-3 text-muted">Name</div>
                                            <div class="col-sm-9">{{ data.customerId?.name }}</div>
                                        </li>
                                        <li class="row">
                                            <div class="col-sm-3 text-muted">Email</div>
                                            <div class="col-sm-9">{{ data.customerId?.email }}</div>
                                        </li>

                                        <li class="row">
                                            <div class="col-sm-3 text-muted">Country</div>
                                            <div class="col-sm-9">{{ data.customerId?.regCountryName }}</div>
                                        </li>
                                        <li class="row">
                                            <div class="col-sm-3 text-muted">Currency</div>
                                            <div class="col-sm-9">
                                                {{ data.customerId?.currencySymbol }} ({{ data.customerId?.currencyCode
                                                }})
                                            </div>
                                        </li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

        </div>
        <!-- COL-END -->
    </div>
    <!-- ROW-1 CLOSED -->
</div>
<!-- CONTAINER CLOSED -->